import {
  LAST_SUCCESS_SLUG_LOG_IN,
  SPLASH_SCREEN_ON_BOARDING
} from "@/const/local-storage.constants"
import * as userDomain from "@/domain/user"

import type { User } from "@/domain/user"

export abstract class BaseAuthAdapter {
  protected abstract currentUser: User

  protected abstract company: string

  protected createUser = (values: Partial<User>) => {
    return userDomain.createUser(values)
  }

  protected setCurrentUser(
    user: { email: string | null; photoURL?: string | null } | null
  ) {
    if (!user) {
      this.currentUser = this.createUser({ authorized: false })

      const splashScreen = localStorage.getItem(SPLASH_SCREEN_ON_BOARDING)
      const currentSlug = localStorage.getItem(LAST_SUCCESS_SLUG_LOG_IN)

      localStorage.clear()

      if (splashScreen)
        localStorage.setItem(SPLASH_SCREEN_ON_BOARDING, splashScreen)

      if (currentSlug)
        localStorage.setItem(LAST_SUCCESS_SLUG_LOG_IN, currentSlug)

      return
    }

    const { email, photoURL } = user

    this.currentUser = {
      ...this.currentUser,
      company: this.company,
      email: email || "",
      photoURL: photoURL || "",
      authorized: true,
      userNeedVerificationCodeMultiFactor: false
    }
  }
}
